import { createFileRoute } from '@tanstack/react-router'

import { OptOutSourcesScreen } from './-components/opt-out-sources-screen.tsx'

export const Route = createFileRoute('/cs-tools/opt-out-sources')({
  component: OptOutSourcesScreen
})
